/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';
import { basecodereference } from 'projects/icemedx-lib/src/models/ehr/subs/basecodereference';

export class procedure extends IceEntity {
	procedure_key: string = "";
  date_required: any = NaN;
  end_date_required: any = NaN;
  code_list_qualifier_code: string = "";
  procedure_code: string = "";
  procedure_quantity: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;
  contraindication: boolean = false;
  interaction: boolean = false;
  synonym: boolean = false;
  required: boolean = false;
  title: string = "";
  procedure_units: string = "";
  strength: number = 0.0;
  strength_form: string = "";
  strength_units: string = "";

  gettablename(): string {
    return "PROCEDURE";
  }
}
